module.exports = __webpack_public_path__ + "img/header_image.c9be9d0c.png";